import { render, staticRenderFns } from "./mobile-preview.vue?vue&type=template&id=79c5b567&scoped=true&"
import script from "./mobile-preview.vue?vue&type=script&lang=ts&"
export * from "./mobile-preview.vue?vue&type=script&lang=ts&"
import style0 from "./mobile-preview.vue?vue&type=style&index=0&id=79c5b567&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c5b567",
  null
  
)

export default component.exports